import type { PublishedPostDto } from "@nlc/shared-types";

import { ImageOff } from "lucide-react";
import { twMerge } from "tailwind-merge";

import { DesignImage } from "../../media/DesignImage";
import { VideoFrame } from "../../media/VideoFrame";

export function PostThumbnail({
  className,
  post,
}: {
  className?: string;
  post: PublishedPostDto;
}) {
  const design = post.designs.find((design) => design.url);
  const mediaClassName = twMerge("shrink-0 object-cover", className);

  if (design?.url && design.mime.startsWith("image/")) {
    return (
      <DesignImage
        alt={design.name}
        className={mediaClassName}
        sources={[design.thumbnailUrl, design.previewUrl, design.url].flatMap(
          (url) => (url ? [url] : []),
        )}
      />
    );
  }

  if (design?.url && design.mime.startsWith("video/")) {
    return (
      <VideoFrame
        className={mediaClassName}
        title={design.name}
        url={design.url}
      />
    );
  }

  return (
    <div
      className={twMerge(
        "flex shrink-0 items-center justify-center bg-bg-secondary text-fg-quaternary",
        className,
      )}
    >
      <ImageOff className="size-5" />
    </div>
  );
}
